import React from 'react';
import { Button, Card } from 'react-bootstrap';
import format from '~/Utils/format';
import { FaTimesCircle } from 'react-icons/fa';
import {
  EmptyWarning,
  ResumoChavesContainer,
} from '../Negocios/CaixaAprovacao/ResumoChaves/styles';

export default function SelecaoSolicitacao({
  solicitacoesSelecionadas,
  Aprovar,
  Reprovar,
  selecionarTodos,
  limparSelecao,
}) {
  const valorTotal = solicitacoesSelecionadas.reduce(
    (total, curr) => total + curr.valor,
    0
  );
  const temSolicitacao = solicitacoesSelecionadas.length > 0;

  const podeAprovarOuRecusar = () => {
    for (let i = 0; i < solicitacoesSelecionadas.length; i++) {
      if (
        solicitacoesSelecionadas[i].status_solicitacao === 2 || // processado
        solicitacoesSelecionadas[i].status_solicitacao === 3 // recusado
      ) {
        return false;
      }
    }
    return true;
  };

  return (
    <ResumoChavesContainer>
      <Card>
        <Card.Body>
          <header>
            {temSolicitacao && (
              <>
                <div>
                  <small>
                    <strong>{solicitacoesSelecionadas.length}</strong>{' '}
                    solicitações selecionadas
                  </small>
                </div>
                <small className="text-muted">Total</small>
                <h5>{format.money(valorTotal)}</h5>
                <hr />
              </>
            )}
            {!temSolicitacao && (
              <EmptyWarning>
                <p>
                  Nenhuma solicitação selecionada. Clique no card para
                  selecionar.
                  <Button variant="primary" onClick={selecionarTodos}>
                    Selecionar Todos
                  </Button>
                </p>
                <p>
                  Selecione um ou mais cards para aprová-los ou reprová-los.
                </p>
              </EmptyWarning>
            )}
          </header>
          <main>
            {solicitacoesSelecionadas.map((solicitacao, index) => (
              <div
                key={index}
                className="px-2 mb-2 border position-relative arrow-bottom-left-primary"
              >
                <p>{format.money(solicitacao.valor)}</p>
              </div>
            ))}
          </main>
          {temSolicitacao && (
            <div className="mt-2">
              <Button
                variant="secondary"
                onClick={() => {
                  limparSelecao();
                }}
                className="d-flex align-items-center justify-content-center"
                disabled={!temSolicitacao}
              >
                <FaTimesCircle className="mr-1" /> Limpar Seleção
              </Button>
            </div>
          )}
          <footer className="mt-2">
            <Button
              variant="danger"
              onClick={Reprovar}
              disabled={!temSolicitacao || !podeAprovarOuRecusar()}
              title={
                !podeAprovarOuRecusar()
                  ? 'Já existem solicitações aprovadas/recusadas nessa seleção'
                  : ''
              }
            >
              REPROVAR
            </Button>
            <Button
              variant="success"
              onClick={Aprovar}
              disabled={!temSolicitacao || !podeAprovarOuRecusar()}
              title={
                !podeAprovarOuRecusar()
                  ? 'Já existem solicitações aprovadas/recusadas nessa seleção'
                  : ''
              }
            >
              APROVAR
            </Button>
          </footer>
        </Card.Body>
      </Card>
    </ResumoChavesContainer>
  );
}
